import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { RISK_COLOR_CLASS } from '@nk/utils-lib';

@Pipe({
  standalone: true,
  name: 'fraudScoreRiskColorClass',
})
@Injectable()
export class FraudScoreRiskColorClassPipe implements PipeTransform {
  public transform(value: number): string {
    // A very simple, preliminary adjustment to the score.
    // Will probably need tuning/additions.
    const adjustedScore = value / 2;
    if (adjustedScore <= 0) {
      return RISK_COLOR_CLASS.low;
    } else if (adjustedScore <= 10) {
      return RISK_COLOR_CLASS.medium;
    } else if (adjustedScore <= 20) {
      return RISK_COLOR_CLASS.high;
    } else {
      return RISK_COLOR_CLASS.very_high;
    }
  }
}
